// The email a participant gets when their enrollment is moved to another
// group. The question is asked after the move, never sent by itself: a move
// is usually agreed on the phone and sometimes undone before anybody saves
// the form (28.09.2026).

// Who actually holds a place in a group — mirrors NOTIFY_STATUSES on the
// backend. Somebody cancelled, abandoned or still at the payment page has no
// programme to receive: session dates would read as a confirmation.
export const NOTIFY_STATUSES = ["paid", "confirmed", "submitted"];

// Why the question is NOT offered, in the operator's words. Empty string when
// it is: a silent absence is what makes people think the feature is broken.
export function whyNotNotify(enrollment) {
  if (!enrollment) return "Înscrierea nu a fost încărcată.";
  if (!enrollment.group_id) return "Înscrierea nu are grupă.";
  if (!(enrollment.email || "").trim()) return "Înscrierea nu are adresă de email.";
  if (!NOTIFY_STATUSES.includes(enrollment.status)) {
    return "Înscrierea nu ține un loc în grupă, așa că nu îi trimitem programul.";
  }
  return "";
}

export function canNotifyGroupChange(enrollment) {
  return whyNotNotify(enrollment) === "";
}

export function groupChangeQuestion(enrollment) {
  const name = (enrollment?.prenume || "").trim();
  const group = (enrollment?.group_snapshot?.name || "").trim();
  const who = name ? `lui ${name}` : "participantului";
  return group
    ? `Îi trimit ${who} programul grupei „${group}"?`
    : `Îi trimit ${who} noul program pe email?`;
}

// What the email will carry, so the operator sees it before sending. A group
// without exact sessions still has its weekly pattern.
export function scheduleNote(enrollment) {
  const snap = enrollment?.group_snapshot || {};
  const sessions = snap.sessions || [];
  if (sessions.length) {
    return `Emailul cuprinde toate cele ${sessions.length} sesiuni, cu date și ore.`;
  }
  const label = (snap.schedule_label || "").trim();
  return label
    ? `Grupa nu are încă sesiuni exacte, așa că emailul poartă programul general: ${label}.`
    : "Grupa nu are încă nici sesiuni, nici program săptămânal — emailul va spune că urmează să fie comunicat.";
}
